const transitionBehavior = {
  name: "transition-behavior",
  path: "/transition-behavior",
  title: "transition-behavior",
  description: "Utilities for controlling the transition-behavior CSS property.",
  value: {
    'transition-behavior': {
      'transition-normal': 'normal',
      'transition-discrete': 'allow-discrete',
    },
  },
  exampleData: [
    {
      example: {
        code: `<div class="transition-all transition-normal duration-500 hover:bg-color-indigo-500 w-32 h-16 bg-color-blue-500"></div>
<div class="transition-all transition-discrete duration-500 hover:bg-color-indigo-500 w-32 h-16 bg-color-blue-500 mt-4"></div>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">transition-normal</code> for normal transitions, or <code class="text-color-gray-800 dark:text-color-white font-semibold">transition-discrete</code> to allow discrete transitions.
      </p>
      <div class="flex gap-4">
        <div>
        <p class="mb-2 text-xs text-color-gray-500 dark:text-color-gray-400">transition-normal</p>
          <div class="transition-all transition-normal duration-500 hover:bg-color-indigo-500 w-32 h-16 bg-color-blue-500"></div>
        </div>
        <div>
        <p class="mb-2 text-xs text-color-gray-500 dark:text-color-gray-400">transition-discrete</p>
          <div class="transition-all transition-discrete duration-500 hover:bg-color-indigo-500 w-32 h-16 bg-color-blue-500"></div>
        </div>
      </div>
      `
    }
  ]
};

export default transitionBehavior;
<div className="sr-only transition-normal transition-discrete"></div>